<template>
  <a-modal
    title="确认付薪信息"
    cancelText="取消"
    okText="确认付薪"
    :width="580"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :bodyStyle="bodyStyle"
    @ok="onSubmit"
    @cancel="handleCancel"
  >
    <div class="content">
      <a-row>
        <a-col :span="spanLeft">支付笔数：</a-col>
        <a-col :span="spanRight">{{ info.totalInfo && info.totalInfo.count }}笔</a-col>
      </a-row>
      <a-row>
        <a-col :span="spanLeft">账户支出：</a-col>
        <a-col :span="spanRight">{{ info.totalInfo && info.totalInfo.total_pay }}元</a-col>
      </a-row>
      <a-row>
        <a-col :span="spanLeft">账户可用余额：</a-col>
        <a-col :span="spanRight">{{ canUseMoney }}元 <a @click="navigate('/recharge')" style="margin-left: 6px">充值</a></a-col>
      </a-row>
      <a-row v-if="openSwitch">
        <a-col :span="spanLeft">支付密码：</a-col>
        <a-col :span="spanRight" class="flex-box">
          <a-input
            style="width: 200px"
            type="password"
            placeholder="请输入6位数密码"
            :maxLength="6"
            :disabled="confirmLoading"
            v-model="password"
          />
          <a @click="navigate('/pay-security')" style="margin-left: 6px">忘记支付密码</a>
        </a-col>
      </a-row>
    </div>
  </a-modal>
</template>

<script>
import { importExcelSubmit, paymentBalance } from '@/api/request'
import { checkPassword, getMobileUserinfo } from '@/api/hp-request'
import Pub from '@/utils/public'
import { mapState } from 'vuex'

export default {
  data () {
    return {
      // 显示/加载
      visible: false,
      confirmLoading: false,
      // 样式
      bodyStyle: {
        padding: '16px 24px'
      },
      spanLeft: 6,
      spanRight: 18,
      info: {},
      password: undefined,
      canUseMoney: 0,
      // 是否开启密码支付
      openSwitch: 0,
    }
  },
  computed: {
    ...mapState({
      permissions: state => state.permissions
    })
  },
  methods: {
    // 显示
    showModal (info) {
      // 显示
      this.visible = true
      this.info = info
      // 获取是否开启密码支付
      this.getMobileUserinfo()
      // 获取账户余额
      this.getpaymentBalance()
    },
    // 获取是否开启密码支付
    getMobileUserinfo () {
      getMobileUserinfo().then(res => {
        const { code, data, msg } = res
        if (code === 0) {
          this.openSwitch = data.wx_pay_auth
        }
      })
    },
    // 获取账户余额
    getpaymentBalance () {
      this.confirmLoading = true
      paymentBalance().then(res => {
        this.confirmLoading = false
        const { code, data, message } = res
        if (code === 0) {
          const canUseMoney = Number(data.can_use_money || 0)
          this.canUseMoney = Pub.KEEP_NUMBER_DECIMAL(canUseMoney / 100, 2)
        } else {
          this.$message.error(message)
        }
      }).catch(() => {
        this.confirmLoading = false
        this.$message.error('获取可用余额失败')
      })
    },
    // 隐藏
    handleCancel () {
      if (!this.confirmLoading) {
        this.visible = false
        this.info = {}
        this.password = undefined
        this.canUseMoney = 0
      }
    },
    // 新开窗口跳转，并且先关闭当前弹窗
    navigate (url) {
      Pub.OPEN_ROUTER(url)
      this.handleCancel()
    },
    // 支付前校验密码
    checkPassword () {
      const { password } = this
      if (!password) {
        return this.$message.error('请输入支付密码')
      }
      this.confirmLoading = true
      checkPassword({
        wx_pay_password: password
      }).then(res => {
        this.confirmLoading = false
        const { code, data, message } = res
        if (code === 0) {
          // 继续提交数据
          this.importExcelSubmit()
        } else {
          this.$message.error(message)
        }
      })
    },
    // 提交数据
    importExcelSubmit () {
      this.confirmLoading = true
      const params = {
        project_id: this.info.projectId,
        excel_data: this.info.dataSource
      }
      importExcelSubmit(params).then(res => {
        this.confirmLoading = false
        const { code, data, message } = res
        if (code === 0) {
          this.$message.success('操作成功')
          // 回到上一步
          this.$emit('success')
          this.handleCancel()
        } else {
          if (code === -200) {
            this.$error({
              title: '账户余额不足！',
              content: '请先充值。'
            })
          } else {
            this.$message.error(message)
          }
        }
      })
    },
    // 提交
    onSubmit () {
      // 检查是否有权限
      if (!this.permissions.includes('pay_commit')) {
        this.$message.error('没有操作权限')
        return
      }
      // 如果开启了密码支付需要先校验密码
      if (this.openSwitch) {
        this.checkPassword()
      } else {
        this.importExcelSubmit()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  padding: 20px;
  .ant-row {
    margin-bottom: 12px;
    height: 32px;
    line-height: 32px;
    .ant-col-6 {
      text-align: right;
    }
    .flex-box {
      display: flex;
      height: 32px;
      .ant-input-affix-wrapper {
        width: 200px;
        margin-right: 8px;
      }
    }
  }
}
</style>